export enum EligibilityStatus {
  ELIGIBLE = 'ELIGIBLE',
  INELIGIBLE = 'INELIGIBLE',
}

export enum EligibilityReason {
  NOT_IN_COHORT = 'NOT_IN_COHORT',
  FEATURE_DISABLED = 'FEATURE_DISABLED',
}

export type Eligible = {
  status: EligibilityStatus.ELIGIBLE;
  reason: null;
};

export type Ineligible = {
  status: EligibilityStatus.INELIGIBLE;
  reason: EligibilityReason;
};

export type Eligibility = Eligible | Ineligible;
